import React from 'react';
import type { IconType } from 'react-icons';

interface IconWrapperProps {
  icon: IconType;
  className?: string;
}

const IconWrapper: React.FC<IconWrapperProps> = ({ icon: Icon, className }) => {
  const IconComponent = Icon as any;
  return <IconComponent className={className} />;
};

export default IconWrapper;
